import { render, staticRenderFns } from "./partTimeDetail.vue?vue&type=template&id=255d2978&scoped=true"
import script from "./partTimeDetail.vue?vue&type=script&lang=js"
export * from "./partTimeDetail.vue?vue&type=script&lang=js"
import style0 from "./partTimeDetail.vue?vue&type=style&index=0&id=255d2978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255d2978",
  null
  
)

export default component.exports